import React from 'react';

/**
 * Shared Button component.
 *
 * Centralizes the app's CTA styling so we don't get visual drift
 * (mismatched padding, opacity, font-weight) across the many places
 * a primary/secondary/ghost action button is needed.
 */
const VARIANT_CLASSES = {
  primary:
    'bg-gradient-to-br from-primary to-primary-dim text-white shadow-md hover:shadow-lg hover:-translate-y-0.5 disabled:opacity-60 disabled:hover:translate-y-0 disabled:cursor-not-allowed',
  secondary:
    'bg-secondary text-on-secondary shadow-md hover:shadow-lg hover:-translate-y-0.5 disabled:opacity-60 disabled:hover:translate-y-0 disabled:cursor-not-allowed',
  outline:
    'bg-transparent text-primary border border-primary hover:bg-primary-container disabled:opacity-60 disabled:cursor-not-allowed',
  ghost:
    'bg-white/20 backdrop-blur-md text-white border border-white/30 hover:bg-white/30 disabled:opacity-60 disabled:cursor-not-allowed',
  danger:
    'bg-error text-white shadow-md hover:shadow-lg disabled:opacity-60 disabled:cursor-not-allowed',
};

const SIZE_CLASSES = {
  sm: 'px-4 py-2 text-sm',
  md: 'px-5 py-2.5 text-sm',
  lg: 'w-full py-3',
  xl: 'w-full py-4',
};

export default function Button({
  as: Component = 'button',
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
  children,
  ...rest
}) {
  const classes = [
    'inline-flex items-center justify-center gap-2 rounded-full font-semibold transition-all',
    VARIANT_CLASSES[variant] || VARIANT_CLASSES.primary,
    SIZE_CLASSES[size] || SIZE_CLASSES.md,
    fullWidth ? 'w-full' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Component className={classes} {...rest}>
      {children}
    </Component>
  );
}
